import useRootData from "~/hooks/useRootData";

export default function useLoginStatus() {
	return useRootData()?.loginStatus;
}
